import { render, staticRenderFns } from "./EditorTask.vue?vue&type=template&id=3490f8cc"
import script from "./EditorTask.vue?vue&type=script&lang=js"
export * from "./EditorTask.vue?vue&type=script&lang=js"
import style0 from "./EditorTask.vue?vue&type=style&index=0&id=3490f8cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports